import {findIndex, mapKeys} from 'lodash'
import React from 'react'
import Text from 'react-text'
import Label from '../../label'
import LessonLinks from './lesson-links'
import {Consumer} from '../../../context'
import {enhancedWithRowData, enhancedWithSortColumns} from '../../../helpers/utils'
import update from 'immutability-helper'

function CatalogueSearchHeader ({sortColumns, title}) {
  const active = sortColumns && sortColumns.id == title
  const direction = active ? (sortColumns.sortAscending ? 'ascending' : 'descending') : ''
  return (
    <span className="sorted-column-wrapper">
      <span className={direction}/>
      <span><Text id={`${title}_catalog_search_header`} /></span>
    </span>
  )
}

function EmptyHeader () { return (<span />) }

function LabelColumn (maxLength) {
  return ({value, sortColumns}) => {
    return <Label {...{value, maxLength}} />   
  }
}

function LessonColumn ({rowData}) {
  const {lesson, lessonName} = rowData
  return (<Consumer>{context => {
    const {newPlan} = context
    const {content = {}} = newPlan
    const {lessons: planLessons = []} = content
    const index = findIndex(planLessons, ({id}) => lesson == id)
    const assigned = index >= 0
    const assignedClass = `lesson-code${assigned ? ' assigned' : ''}`
    const title = context.translate(assigned ? 'remove-lesson-from-plan' : 'add-lesson-to-plan')
    return (
      <div className={assignedClass} title={title} onClick={() => {
        const lessons = update(planLessons, assigned
          ? {$splice: [[index,1]]}
          : {$push: [{id: lesson, name: lessonName}]})
        context.setState({newPlan: {...newPlan, content: {...content, lessons}}})
      }}>
        <div className="bullet"></div>
        <div className="code">{lesson}</div>
      </div>
    )
  }}</Consumer>)
}

function LessonLinksColumn ({rowData}) {
  const map = { lesson: 'id', lessonName: 'name'}
  const props = mapKeys(rowData, (_, key) => map[key] || key)
  return (<LessonLinks {...props} />)
}

const map = {
  headers: {CatalogueSearchHeader: enhancedWithSortColumns(CatalogueSearchHeader), EmptyHeader},
  columns: {
    LessonColumn: enhancedWithRowData(LessonColumn),
    LessonLinksColumn: enhancedWithRowData(LessonLinksColumn),
    LabelColumn
  }
}

export default map
